import React, { useState, useEffect } from 'react';
import "../Diagnostic/PackageDetail.css";
import { Link, useNavigate } from "react-router-dom";
import Header from '../components/Header';
import Footer from '../components/Footer';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WhyTrust from '../layout/WhyTrust';
import { fetchUserAppAPI } from '../utils/api';

export default function IcuInstallationEnquiry() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    hospitalName: '',
    plotNo: '',
    locality: '',
    area: '',
    pincode: ''
  });

  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedCityId, setSelectedCityId] = useState("");
  const [selectedLocalityId, setSelectedLocalityId] = useState("");
  const [selectedAreaId, setSelectedAreaId] = useState("");

  const [statesList, setStatesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [localitiesList, setLocalitiesList] = useState([]);
  const [areasList, setAreasList] = useState([]);

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchStates();
    // Prefill logged in user details
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const u = JSON.parse(storedUser);
        const fullName = `${u.user_first_name || ""} ${u.user_last_name || ""}`.trim();
        setFormData((prev) => ({
          ...prev,
          name: fullName || prev.name,
          phone: u.user_mobile || prev.phone,
          email: u.user_email || prev.email
        }));
      } catch (e) {}
    }
  }, []);

  const fetchStates = async () => {
    try {
      const res = await fetchUserAppAPI("get-state", { method: "GET" });
      if (res && res.status === 200 && Array.isArray(res.result)) {
        setStatesList(res.result);
      }
    } catch (err) {
      console.error("Error fetching states:", err);
    }
  };

  const fetchCities = async (stateId) => {
    setCitiesList([]);
    setLocalitiesList([]);
    setAreasList([]);
    setSelectedCityId("");
    setSelectedLocalityId("");
    setSelectedAreaId("");
    setFormData(prev => ({ ...prev, locality: "", area: "", pincode: "" }));

    if (!stateId) return;

    try {
      const res = await fetchUserAppAPI("get-city-by-state", {
        method: "POST",
        body: JSON.stringify({ state_id: stateId }),
      });
      if (res && res.status === 200 && Array.isArray(res.result)) {
        setCitiesList(res.result);
      }
    } catch (err) {
      console.error("Error fetching cities:", err);
    }
  };

  const fetchLocalities = async (cityId) => {
    setLocalitiesList([]);
    setAreasList([]);
    setSelectedLocalityId("");
    setSelectedAreaId("");
    setFormData(prev => ({ ...prev, locality: "", area: "", pincode: "" }));

    if (!cityId) return;

    try {
      const res = await fetchUserAppAPI("get-locality-by-city", {
        method: "POST",
        body: JSON.stringify({ city_id: cityId }),
      });
      if (res && res.status === 200 && Array.isArray(res.result)) {
        setLocalitiesList(res.result);
      }
    } catch (err) {
      console.error("Error fetching localities:", err);
    }
  };

  const fetchAreas = async (localityId) => {
    setAreasList([]);
    setSelectedAreaId("");
    setFormData(prev => ({ ...prev, area: "", pincode: "" }));

    if (!localityId) return;

    try {
      const res = await fetchUserAppAPI("get-area-by-locality", {
        method: "POST",
        body: JSON.stringify({ locality_id: localityId }),
      });
      if (res && res.status === 200 && Array.isArray(res.result)) {
        setAreasList(res.result);
      }
    } catch (err) {
      console.error("Error fetching areas:", err);
    }
  };

  const handleStateChange = (e) => {
    const sId = e.target.value;
    setSelectedStateId(sId);
    fetchCities(sId);
  };

  const handleCityChange = (e) => {
    const cId = e.target.value;
    setSelectedCityId(cId);
    fetchLocalities(cId);
  };

  const handleLocalityChange = (e) => {
    const locVal = e.target.value;
    if (!locVal) {
      setSelectedLocalityId("");
      setFormData(prev => ({ ...prev, locality: "" }));
      fetchAreas("");
      return;
    }
    const foundLoc = localitiesList.find(
      (l) => String(l.locality_id) === String(locVal) || l.locality_name === locVal
    );
    if (foundLoc) {
      setSelectedLocalityId(foundLoc.locality_id);
      setFormData(prev => ({ ...prev, locality: foundLoc.locality_name }));
      fetchAreas(foundLoc.locality_id);
    } else {
      setSelectedLocalityId("");
      setFormData(prev => ({ ...prev, locality: locVal }));
      fetchAreas("");
    }
  };

  const handleAreaChange = (e) => {
    const areaVal = e.target.value;
    if (!areaVal) {
      setSelectedAreaId("");
      setFormData(prev => ({ ...prev, area: "", pincode: "" }));
      return;
    }
    const foundArea = areasList.find(
      (a) => String(a.area_id) === String(areaVal) || a.area_name === areaVal
    );
    if (foundArea) {
      setSelectedAreaId(foundArea.area_id);
      setFormData(prev => ({
        ...prev,
        area: foundArea.area_name,
        pincode: foundArea.area_pincode || prev.pincode
      }));
    } else {
      setSelectedAreaId("");
      setFormData(prev => ({ ...prev, area: areaVal }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.phone || !formData.hospitalName) {
      alert("Please fill in all required fields.");
      return;
    }

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
    }, 800);
  };

  return (
    <>
      <Header />

      <div className="test_bredcum_sec">
        <div className="container-fluid">
          <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <Link to="/icu-installation-service">ICU Setup At Hospital</Link>
            <span>&gt;</span>
            <span className='name_p'>ICU Installation Enquiry</span>
          </div>
        </div>
      </div>

      <div className="booking_form_main">
        <div className="container-fluid">
          <div className="inner_booking_form">
            <div className="row justify-content-center">
              <div className="col-lg-8 col-md-10 col-12">
                <div className="booking_box patient_info_form">
                  <h3 className="fw-bold mb-3" style={{ color: "#13505b" }}>ICU Installation Enquiry</h3>
                  {submitted ? (
                    <div className="text-center py-5">
                      <CheckCircleOutlineIcon style={{ fontSize: "64px", color: "#13baac" }} />
                      <h4 className="fw-bold mt-3" style={{ color: "#13505b" }}>Enquiry Submitted Successfully!</h4>
                      <p className="text-muted mt-2">
                        Thank you <strong>{formData.name}</strong>. Our ICU setup specialists will contact you shortly regarding <strong>{formData.hospitalName}</strong>.
                      </p>
                      <button
                        className="btn text-white fw-bold px-4 py-2 mt-3"
                        style={{ backgroundColor: "#13505b", borderRadius: "8px" }}
                        onClick={() => navigate("/icu-installation-service")}
                      >
                        Back to ICU Hospital Setup
                      </button>
                    </div>
                  ) : (
                    <div className="form_patient_info">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-12 mb-3">
                            <label className="form-label text-dark fw-bold mb-1">Full Name *</label>
                            <input
                              type="text"
                              name="name"
                              className="form-control"
                              placeholder="Enter your full name"
                              required
                              value={formData.name}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label text-dark fw-bold mb-1">Phone Number *</label>
                            <input
                              type="tel"
                              name="phone"
                              className="form-control"
                              placeholder="Enter 10-digit mobile number"
                              required
                              value={formData.phone}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label text-dark fw-bold mb-1">Email Address</label>
                            <input
                              type="email"
                              name="email"
                              className="form-control"
                              placeholder="Enter your email"
                              value={formData.email}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="col-12 mb-3">
                            <label className="form-label text-dark fw-bold mb-1">Hospital / Facility Name *</label>
                            <input
                              type="text"
                              name="hospitalName"
                              className="form-control"
                              placeholder="Enter hospital / facility name"
                              required
                              value={formData.hospitalName}
                              onChange={handleChange}
                            />
                          </div>

                          {/* Address Details Section */}
                          <div className="col-12 mb-2 mt-2">
                            <h5 className="fw-bold" style={{ color: "#13505b", fontSize: "16px" }}>Address Details</h5>
                          </div>

                          <div className="col-12 mb-3">
                            <label className="form-label text-dark fw-bold mb-1">Plot / Flat / Street Address *</label>
                            <input
                              type="text"
                              name="plotNo"
                              className="form-control"
                              placeholder="Enter building, plot or street address"
                              required
                              value={formData.plotNo}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label text-dark fw-bold mb-1">State *</label>
                            <select
                              className="form-select"
                              value={selectedStateId}
                              onChange={handleStateChange}
                              required
                            >
                              <option value="">Select State</option>
                              {statesList.map((st) => (
                                <option key={st.state_id} value={st.state_id}>
                                  {st.state_name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label text-dark fw-bold mb-1">City *</label>
                            <select
                              className="form-select"
                              value={selectedCityId}
                              onChange={handleCityChange}
                              required
                              disabled={!selectedStateId}
                            >
                              <option value="">Select City</option>
                              {citiesList.map((ct) => (
                                <option key={ct.city_id} value={ct.city_id}>
                                  {ct.city_name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label text-dark fw-bold mb-1">Locality / Sector *</label>
                            {localitiesList.length > 0 ? (
                              <select
                                className="form-select"
                                value={selectedLocalityId || formData.locality}
                                onChange={handleLocalityChange}
                                required
                                disabled={!selectedCityId}
                              >
                                <option value="">Select Locality</option>
                                {localitiesList.map((loc) => (
                                  <option key={loc.locality_id} value={loc.locality_id}>
                                    {loc.locality_name}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <input
                                type="text"
                                name="locality"
                                className="form-control"
                                placeholder="Enter Locality / Sector"
                                value={formData.locality}
                                onChange={handleChange}
                                required
                                disabled={!selectedCityId}
                              />
                            )}
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label text-dark fw-bold mb-1">Area / Landmark *</label>
                            {areasList.length > 0 ? (
                              <select
                                className="form-select"
                                value={selectedAreaId || formData.area}
                                onChange={handleAreaChange}
                                required
                                disabled={!selectedLocalityId}
                              >
                                <option value="">Select Area</option>
                                {areasList.map((ar) => (
                                  <option key={ar.area_id} value={ar.area_id}>
                                    {ar.area_name}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <input
                                type="text"
                                name="area"
                                className="form-control"
                                placeholder="Enter Area / Landmark"
                                value={formData.area}
                                onChange={handleChange}
                                required
                                disabled={!selectedCityId}
                              />
                            )}
                          </div>

                          <div className="col-md-12 mb-4">
                            <label className="form-label text-dark fw-bold mb-1">Pincode *</label>
                            <input
                              type="text"
                              name="pincode"
                              className="form-control"
                              placeholder="Enter 6-digit Pincode"
                              value={formData.pincode}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          <div className="col-12">
                            <button
                              type="submit"
                              disabled={loading}
                              className="btn w-100 text-white fw-bold py-3"
                              style={{
                                backgroundColor: "#13505b",
                                borderRadius: "8px",
                                fontSize: "18px"
                              }}
                            >
                              {loading ? "Submitting..." : "Submit Enquiry"} <EastOutlinedIcon className="ms-2" />
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <WhyTrust />
      </div>

      <Footer />
    </>
  );
}
